/* eslint-disable */
<template>
  <div ref="div" class="goods-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />

    <div class="studentAuth">
      <!-- 头部 -->
      <img id="img" src="../../../images/auth/img_BG.png" alt="" v-if="authStep == 'NotStarted'" />
      <!-- 认证表单部分 -->
      <div class="auth" v-show="authStep == 'NotStarted' || authStep == 'again'">
        <div class="content" v-if="authStep == 'NotStarted'">
          <div class="tip">
            <img src="../../../images/auth/auth.png" alt="" />
          </div>
          <div class="tip_title">成为认证校园用户</div>
          <div class="tip_text">即可获得7天免费外刊听课权益</div>
        </div>
        <!-- 首次认证 -->
        <div class="form" v-if="authStep == 'NotStarted'">
          <div class="input1 input2">
            <img src="../../../images/auth/icon_certify_id.png" alt="" />
            <input
              v-model="sfzValue"
              style="width: 100%"
              type="idcard"
              maxlength="18"
              name="idCard"
              placeholder="请输入身份证号"
            />
          </div>
          <div class="input1">
            <img src="../../../images/auth/icon_certify_student.png" alt="" />
            <input
              v-model="xszValue"
              style="width: 100%"
              type="text"
              maxlength="30"
              name="studentNo"
              placeholder="请输入学生证号"
            />
          </div>
          <div class="agree_rule">
            <img @click="agree" v-if="!agreeData" src="../../../images/auth/auth_radio.png" alt="" />
            <img @click="agree" v-if="agreeData" src="../../../images/auth/auth_radio_checked.png" alt="" />
            <div class="link">
              阅读并同意
              <div class="name" @click="goWebview">《友邻少年用户许可协议和隐私政策议》</div>
            </div>
          </div>
          <button @click="onStudentAuth" :class="agreeData ? 'abled' : ''" :disabled="!agreeData">提交认证</button>
        </div>
        <!-- 辅助认证 -->
        <div class="form form2" v-show="authStep == 'again'">
          <div class="input1 input2">
            <div class="sfz">
              身份证号
              <div class="x">*</div>
            </div>
            <input
              v-model="sfzValue"
              style="width: 100%"
              type="idcard"
              maxlength="18"
              name="idCard"
              placeholder="请输入身份证号"
            />
          </div>
          <div class="input1">
            <div class="xsz">
              学生证号
              <div class="x">*</div>
            </div>
            <input
              v-model="xszValue"
              style="width: 100%"
              type="text"
              maxlength="30"
              name="studentNo"
              placeholder="请输入学生证号"
            />
          </div>
          <div class="file">
            <div class="xsz">
              请上传学生证照片
              <div class="x">*</div>
            </div>
            <!-- <img class="img2"  :src='endsrc'/> -->
            <canvas
              @click="chooseImage"
              v-show="tempFilePaths != ''"
              id="canvas"
              class="canvas"
              canvas-id="firstCanvas"
            ></canvas>
            <div class="div" @click="chooseImage" v-if="tempFilePaths == ''">
              <img class="img2" src="https://img-cdn1.ylyk.com/image/1616565915091_m1616568385635_s288.jpg" />
            </div>
          </div>
          <div class="agree_rule">
            <img @click="agree" v-if="!agreeData" src="../../../images/auth/auth_radio.png" alt="" />
            <img @click="agree" v-if="agreeData" src="../../../images/auth/auth_radio_checked.png" alt="" />
            <div class="link">
              阅读并同意
              <div class="name" @click="goWebview">《友邻少年用户许可协议和隐私政策议》</div>
            </div>
          </div>
          <button @click="onStudentAuth" :class="agreeData ? 'abled' : ''" :disabled="!agreeData">提交认证</button>
        </div>
      </div>

      <!-- 认证结果提示框 -->
      <div class="success" v-if="authStep == 'Successed'">
        <img src="https://img-cdn1.ylyk.com/image/1616565915091_m1616566047419_s12967.jpg" alt="" />
        <div class="tips">
          <div class="title">恭喜您！已认证成功</div>
          <div class="p">已获得7天免费外刊听课权益</div>
        </div>
        <div class="button" @click="onGotoBuy">去购买</div>
      </div>
      <div class="success" v-if="authStep == 'fail'">
        <img src="https://img-cdn1.ylyk.com/image/1616565915091_m1616566006168_s25127.jpg" alt="" />
        <div class="tips">
          <div class="title">抱歉，您的信息未能通过认证</div>
          <div class="p">请重新认证，上传学生证照片</div>
        </div>
        <div class="button" @click="againAuth">重新认证</div>
      </div>
      <div class="success" v-if="authStep == 'auth'">
        <img src="https://img-cdn1.ylyk.com/image/1618454879014_m1618454829113_s10810.jpg" alt="" />
        <div class="tips">
          <div class="title">提交成功，等待审核中</div>
          <div class="p">预计审核将在3-5个工作日内完成</div>
        </div>
        <div class="button" @click="onGoIndex">确定</div>
        <div class="tip">关注“友邻少年”公众号，第一时间知晓审核结果</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
// import plupload from 'plupload'

export default {
  name: 'goods',
  data() {
    return {
      title: '大学生认证',
      authStep: 'NotStarted', // NotStarted , Successed,fail,auth,again
      // 是否是提交中
      submitLoading: false,
      agreeData: false,
      tempFilePaths: '',
      canvasHeight: '',
      canvasWidth: '',
      source: '',
      goodsId: '',
      sfzValue: '',
      xszValue: '',
      endsrc: ''
    }
  },
  created() {
    console.log('$route', this.$route.query)
    switch (this.$route.query.status * 1) {
      case 0: {
        this.authStep = 'auth' // 待审核/审核中
        break
      }
      case 1: {
        this.authStep = 'Successed' // 认证成功
        break
      }
      case 2: {
        this.authStep = 'fail' // 审核不通过
        break
      }
      case 3: {
        this.authStep = 'Successed' // 审核通过
        break
      }
    }
  },
  methods: {
    goBack: function () {
      if (this.data.authStep == 'Successed') {
        // eslint-disable-next-line no-undef
        App.globalData.myPageRefresh = true
      }
      // eslint-disable-next-line no-undef
      wx.navigateBack({
        delta: 1
      })
    },
    agree: function () {
      this.agreeData = !this.agreeData
    },
    goWebview: function () {
      this.$router.push({ path: '/miniAppAgreement' })
      // window.open('https://new-wx.ylyk.com/static/miniAppAgreement.html')
      // location.href = 'https://new-wx.ylyk.com/static/miniAppAgreement.html';
    },
    onStudentAuth: function (e) {
      const postData = {
        idCard: this.sfzValue,
        studentNo: this.xszValue,
        activityId: 1
      }
      console.log('postData', postData)
      // debugger
      if (postData.idCard == '') {
        Toast({
          message: '请输入身份证号'
        })
        return
      }
      if (postData.studentNo == '') {
        Toast({
          message: '请输入学生证号'
        })
        return
      } else {
        var reg = /^[0-9a-zA-Z]+$/
        if (!reg.test(postData.studentNo)) {
          Toast({
            message: '学生证号码格式错误，请重新输入'
          })
          return
        }
      }
      if (this.authStep == 'again' && this.endsrc == '') {
        Toast({
          message: '请上传图片'
        })
        return
      }
      if (this.authStep == 'again') {
        postData.evidence3 = 'aliOSS:images/mini/' + this.endsrc
      } else {
        postData.evidence3 = ''
      }
      const that = this
      this.$store
        .dispatch('goods/vip/authentication', postData)
        .then(data => {
          console.log('xn 认证 data', data)
          that.authStep = 'Successed'
        })
        .catch(err => {
          console.log('xn 认证 err', err, err.data.errorCode)
          var code = err.data.errorCode
          if (code == 30306) {
            // 进入人工审核,展示审核中
            that.authStep = 'auth'
          }
        })
    },
    chooseImage: function () {
      console.log('选择图片')
      const that = this
      window.wx.checkJsApi({
        jsApiList: ['chooseImage', 'getLocalImgData'],
        success: function (res) {
          console.log('权限', res)
          if (res.checkResult.chooseImage) {
            window.wx.chooseImage({
              count: 1,
              sizeType: ['original', 'compressed'],
              sourceType: ['album', 'camera'],
              success: res => {
                console.log('选择的照片 res', res)
                // tempFilePath可以作为img标签的src属性显示图片
                that.tempFilePaths = res.localIds[0]
                console.log('res', res, that.tempFilePaths)
                that.watermark()
              },
              fail: err => {
                Toast({
                  message: err
                })
              }
            })
          }
        },
        fail: err => {
          Toast({
            message: err
          })
        }
      })
    },
    watermark() {
      const _this = this
      const tempFilePaths = this.tempFilePaths
      // 获取图片详细信息
      window.wx.getLocalImgData({
        localId: tempFilePaths,
        success: ress => {
          console.log('获取图片详情', tempFilePaths)
          console.log('获取详情成功', ress)
          var localData = ress.localData
          if (localData.indexOf('data:image') != 0) {
            // 判断是否有这样的头部
            localData = 'data:image/jpeg;base64,' + localData
          }
          localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
          var canvas = document.getElementById('canvas')
          var ctx = canvas.getContext('2d')
          var img = new Image() // testimg
          canvas.width = 260
          canvas.height = 260
          img.src = localData
          // 将图片src放到cancas内，宽高为图片大小
          img.onload = function () {
            ctx.drawImage(img, 0, 0, 300, 300)
            ctx.font = '40px 微软雅黑'
            ctx.strokeStyle = 'rgba(153,153,153,0.3)'
            ctx.strokeText('仅供友邻认证', 9, 130)
            ctx.fillStyle = 'rgba(255,255,255,0.3)'
            ctx.fillText('仅供友邻认证', 9, 130)
            //  ctx.fillStyle="#fff";
            //  ctx.fillText("仅供友邻认证", 9, 130)
            console.log('canvas', canvas)
            var src = canvas.toDataURL('image/jpeg')
            console.log('最终链接2', src)
            // base64转blob
            const base64 = src.split(',')[1]
            _this.base64ToBlob({ b64data: base64, contentType: 'image/png' }).then(res => {
              // 转后后的blob对象
              _this.customUpload(res)
            })
          }
        }
      })
    },
    customUpload(src) {
      const that = this
      console.log('获取pocily')
      this.$store
        .dispatch('goods/vip/imageTokenH5', {})
        .then(data => {
          console.log('xn 获取token', data)
          that.uploadAliyun(data, src)
        })
        .catch(err => {
          console.log('获取pocily err', err)
          that.tempFilePaths = ''
          that.endsrc = ''
          Toast({
            message: '我开小差了，重新传一张吧'
          })
        })
    },
    base64ToBlob({ b64data = '', contentType = '', sliceSize = 512 } = {}) {
      return new Promise((resolve, reject) => {
        // 使用 atob() 方法将数据解码
        const byteCharacters = atob(b64data)
        const byteArrays = []
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize)
          const byteNumbers = []
          for (let i = 0; i < slice.length; i++) {
            byteNumbers.push(slice.charCodeAt(i))
          }
          // 8 位无符号整数值的类型化数组。内容将初始化为 0。
          // 如果无法分配请求数目的字节，则将引发异常。
          byteArrays.push(new Uint8Array(byteNumbers))
        }
        let result = new Blob(byteArrays, {
          type: contentType
        })
        result = Object.assign(result, {
          // 这里一定要处理一下 URL.createObjectURL
          preview: URL.createObjectURL(result),
          name: `test.png`
        })
        resolve(result)
      })
    },
    random_string(length) {
      var len = length || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    uploadAliyun(data, src) {
      const that = this
      console.log('上传阿里云函数', data, 'src', src)
      const ossTokenData = data
      const formData = new FormData()
      const key = new Date().getTime() + '_' + this.random_string(16) + '.png'
      // 注意formData里append添加的键的大小写
      formData.append('name', '')
      formData.append('key', 'images/mini/' + key) // 存储在oss的文件路径
      formData.append('OSSAccessKeyId', ossTokenData.accessId) // accessKeyId
      formData.append('policy', ossTokenData.policy) // policy
      formData.append('signature', ossTokenData.signature) // 签名
      // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append('file', src)
      formData.append('success_action_status', '200') // 成功后返回的操作码
      for (const [a, b] of formData.entries()) {
        console.log('formdata', a, b)
      }
      axios({
        method: 'POST',
        url: ossTokenData.host,
        data: formData,
        // async: false,
        cache: false,
        contentType: false, // 必须false才会自动加上正确的Content-Type
        processData: false, // 必须false才会避开jQuery对 formdata 的默认处理
        crossDomain: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(function (res) {
          console.log('阿里云接口 res', res)
          that.endsrc = key
        })
        .catch(err => {
          console.log('阿里云接口 err', err)
          that.tempFilePaths = ''
          that.endsrc = ''
          Toast({
            message: '我开小差了，重新传一张吧'
          })
        })
    },
    onGotoListen: function (e) {
      // eslint-disable-next-line no-undef
      const delta = getCurrentPages().length
      // eslint-disable-next-line no-undef
      if (getCurrentPages().length <= 1) {
        return
      }
      // eslint-disable-next-line no-undef
      wx.navigateBack({
        delta: delta
      })
    },

    onGotoBuy: function (e) {
      console.log('跳转购买')
      this.$router.back(-1)
    },

    againAuth: function () {
      this.authStep = 'again'
      // 重新认证
    },
    onGoIndex: function () {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="less" scoped>
/* pages/studentAuth/studentAuth.wxss */
.studentAuth > img {
  width: 7.5rem;
  height: 7.5rem;
  position: fixed;
  z-index: -1;
  top: 0;
}
.detail_header {
  width: 100%;
}
.detail_header .header_option {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back img {
  width: 0.48rem;
  height: 0.48rem;
  margin-left: 0.34rem;
}
.detail_header .header_option .center {
  display: flex;
  justify-content: center;
  width: 2rem;
  position: relative;
  padding-bottom: 0.2rem;
  color: #fff;
}
.detail_header .header_option .center2 {
  color: #000;
}

.right,
.left {
  width: 2rem;
}

.content .tip img {
  width: 0.96rem;
  height: 0.96rem;
  margin: 0 auto;
  display: block;
  margin-top: 0.8rem;
  margin-bottom: 0.4rem;
}

.content .tip_title {
  font-size: 0.4rem;
  font-weight: bold;
  color: #ffffff;
  width: 100%;
  text-align: center;
  margin-bottom: 0.24rem;
}

.content .tip_text {
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  width: 100%;
  text-align: center;
}

.form {
  width: 6.86rem;
  height: 6.8rem;
  background: #ffffff;
  box-shadow: 0px 0px 0.32rem -0.08rem rgba(0, 0, 0, 0.12);
  border-radius: 0.24rem;
  margin: 0 auto;
  margin-top: 0.82rem;
  padding-top: 1rem;
  box-sizing: border-box;
}
.form img {
  width: 0.4rem;
  height: 0.4rem;
  margin: 0 0.16rem 0 0.24rem;
}
.form .input1 {
  display: flex;
  align-items: center;
  width: 5.9rem;
  height: 0.88rem;
  background: #f7f9fb;
  border-radius: 0.04rem;
  margin: 0 auto;
}
.form input {
  border: 0;
  outline: none;
  background: transparent;
  -webkit-user-select: text !important;
  font-size: 16px;
}
.form .input2 {
  margin-bottom: 0.48rem;
}
.form button {
  width: 3.9rem;
  height: 0.88rem;
  background: #eeeeee;
  border-radius: 0.12rem;
  font-size: 0.32rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.3);
  margin: 0 auto;
  margin-top: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form .abled {
  background: #00b25a;
  color: #fff;
}
.canvas {
  width: 3rem;
  height: 3rem;
  margin-top: 0.32rem;
  z-index: 1;
}
.form2 {
  box-shadow: none;
  margin-top: 0;
  padding-top: 0;
}
.form2 .input1 {
  height: 1.2rem;
  background: #fff;
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
  font-size: 0.28rem;
}
.form2 .input2 {
  margin-bottom: 0;
}
.form2 .input1 div {
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  flex-shrink: 0;
  margin-right: 0.16rem;
  display: flex;
}
.form2 .input1 div .x {
  color: #e65c53;
}
.form2 .file div {
  font-size: 0.32rem;
  font-weight: 400;
  flex-shrink: 0;
  margin-right: 0.16rem;
  display: flex;
}
.form2 .file div .x {
  color: #e65c53;
}
.form2 .file .div {
  width: 3rem;
  height: 3rem;
  background: #f7f9fb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.32rem;
}
.form2 .file .img2 {
  width: 0.72rem;
  height: 0.72rem;
  // padding:.9rem;
  background: #f7f9fb;
  margin-top: 0;
}
.file {
  width: 5.9rem;
  margin: 0 auto;
  margin-top: 0.64rem;
}
.file img {
  display: block;
  margin: 0;
  margin-top: 0.32rem;
}
.file .img {
  display: block;
  margin: 0;
  margin-top: 0.32rem;
  padding: 0;
  width: 2.6rem;
  height: 2.6rem;
}
.vip {
  margin: 0 auto;
  width: 6.54rem;
  height: 3rem;
  margin-top: 0.82rem;
  margin-bottom: 0.8rem;
  position: relative;
}
.vip .title {
  position: absolute;
  top: 0.6rem;
  left: 1.5rem;
  font-size: 0.36rem;
  font-weight: 500;
  color: #8b3c10;
}
.vip .time {
  position: absolute;
  bottom: 0.4rem;
  right: 0.54rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #8b3c10;
}
.success img {
  width: 4rem;
  height: 4rem;
  margin: 1.38rem auto 0.3rem auto;
  display: block;
}
.success .tip {
  font-size: 0.28rem;
  font-weight: 400;
  color: #00b25a;
  line-height: 0.4rem;
  width: 100%;
  text-align: center;
  margin-top: 0.4rem;
}
.tips {
  text-align: center;
}
.tips .title {
  font-size: 0.34rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.9);
  margin: 0 auto 0.2rem auto;
}
.tips .p {
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin: 0 auto;
  margin-bottom: 1.4rem;
}
.button {
  width: 3.9rem;
  height: 0.88rem;
  background: #00b25a;
  border-radius: 0.12rem;
  margin: 0 auto;
  color: #fff;
  line-height: 0.88rem;
  text-align: center;
}

.agree_rule {
  display: flex;
  margin-top: 0.34rem;
  display: flex;
  justify-content: center;
}

.agree_rule img {
  width: 0.32rem;
  height: 0.32rem;
  margin: 0;
  margin-right: 0.16rem;
}
.agree_rule .link {
  font-size: 0.24rem;
  display: flex;
}
.agree_rule .name {
  color: #00b25a;
}
</style>
